import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_COMPANY_MANAGEMENT_DATA = "paginationCompanyManagementData";
export const LIST_COMPANY_MANAGEMENT_DATA = "listCompanyManagementData";
export const GET_COMPANY_MANAGEMENT_DATA = "getCompanyManagementData";
export const POST_COMPANY_MANAGEMENT_DATA = "postCompanyManagementData";
export const PUT_COMPANY_MANAGEMENT_DATA = "putCompanyManagementData";
export const PUT_COMPANY_MANAGEMENT_STATUS_DATA = "putCompanyManagementStatusData";
export const DELETE_COMPANY_MANAGEMENT_DATA = "deleteCompanyManagementData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "company_management",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_COMPANY_MANAGEMENT_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_COMPANY_MANAGEMENT_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
